import 'whatwg-fetch'

import store from '../store'
import router from '../router'

const DEFAULT_FETCH_TIMEOUT = 10000

// WIP: disable warnings
/* eslint-disable */

export default {
  install(Vue, defaultOptions = {}) {
    const coreService = process.env.config.backend.coreService
    const userService = process.env.config.backend.userService
    const defaultQueryOptions = Object.assign(
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      },
      defaultOptions
    )

    Vue.PfxBackendApi = Vue.prototype.$PfxBackendApi = {
      getUserServiceMonitor() {
        return this.query(`${userService}/anon/monitor`)
      },

      getCoreServiceMonitor() {
        return this.query(`${coreService}/anon/monitor`)
      },

      getServerTime() {
        return this.query(`${coreService}/anon/servertime`)
      },

      // Note: this is synchrounous which is BAD. Needed because of mqtt.options.transformWsUrl
      getNotificationUrl() {
        const url = `${coreService}/anon/notifications`
        const request = new XMLHttpRequest()
        request.setTimeout = 3000 // timeout in 3 seconds
        request.open('GET', url, false)
        request.send(null)

        if (request.status !== 200) {
          console.error('getNotificationUrl failed with status [%s]', request.status)
          throw false
        }
        const response = JSON.parse(request.responseText)
        console.log('getNotificationUrl', response)
        return response.url
      },

      postLogin() {
        return this.query(`${coreService}/auth/login`, true)
      },

      getUser(cognitoSub) {
        return this.query(`${userService}/anon/user/${cognitoSub}`)
      },

      postUser(data) {
        return this.query(`${userService}/auth/user`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      createUser(authorization, decodedIdToken) {
        return this.query(`${userService}/auth/user/create`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(decodedIdToken)
          }
        })
      },

      createTenant(subdomain) {
        return this.query(`${coreService}/auth/tenant/${subdomain}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      updateTenant(tenantData) {
        return this.query(`${userService}/auth/tenant`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(tenantData)
          }
        })
      },

      getReservedDomains() {
        return this.query(`${coreService}/anon/tenant/domains`)
      },

      getTenantPublic(subdomain) {
        return this.query(`${userService}/anon/tenant/${subdomain}`)
      },

      getTenantData() {
        return this.query(`${userService}/auth/tenant/${store.getters.subdomain}`, true)
      },

      getTenantStatus(subdomain) {
        return this.query(`${coreService}/anon/tenant/${subdomain}`)
      },

      getTenantMembers() {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/members`, true)
      },

      setTenantStatus(subdomain, status) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/status/${status}`, true, {
          queryOptions: {
            method: 'PUT'
          }
        })
      },

      changeTenantRole(userId, newRole) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/members/${userId}/role/${newRole}`, true, {
          queryOptions: {
            method: 'PUT'
          }
        })
      },

      assignDelegate(role) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/members/${role.userId}/delegate/${role.delegate}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      deleteTenantRole(role) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/members/${role.userId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      getPendingInvitations() {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/invitations`, true)
      },

      createInvitation(email, role) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/invitations/sendInvitation/${role}`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ email: email })
          }
        })
      },

      resendInvitation(token) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/invitations/${token}/resend`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      deleteInvitation(token) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/invitations/${token}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      joinTenant(token) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/invitations/${token}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      getImportBuildOut(apiKey, refresh) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/import/buildout/${apiKey}?refresh=${refresh?'true':''}`, true)
      },

      getImportRets(principal, password, mlsId, refresh) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/import/rets/${principal}/${password}/${mlsId}?refresh=${refresh?'true':''}`, true)
      },

      getPublicAuctions(subdomain, limit) {
          return this.resolveTenantData(this.query(`${coreService}/anon/auctions`, false, {
            params: {
              offset: 0,
              limit: limit || 100,
              subdomain: subdomain
            }
          }))
      },

      getPfxAuctions() {
        return this.resolveTenantData(this.query(`${coreService}/anon/auctions`, false, {
          params: {
            offset: 0,
            limit: 3,
            include: ['OPEN', 'FREEZE', 'AUCTION']
          }
        }))
      },

      // Inject cached tenant logo url to the auction data
      resolveTenantData(query) {
        return new Promise((resolve, reject) => {
          query.then(res => {
            const auctions = res.data.data || []
            const tenants = []
            auctions.map(auction => {
              auction.tenantData = { logoUrl: '', extLogoUrl: '' }
              const subdomain = auction.tenant.subdomain
              if ( tenants.indexOf(subdomain) === -1 ) {
                tenants.push(subdomain)
                this.getTenantPublic(subdomain)
                .then(res => {
                  auctions.forEach(auction => {
                    if ( auction.tenant.subdomain === subdomain ) {
                      auction.tenantData.logoUrl = res.data.logoUrl || ''
                      auction.tenantData.extLogoUrl = res.data.extLogoUrl || ''
                    }
                  })
                })
                .catch(err => {
                  console.error('getTenantData err', err)
                })
              }
            })
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
        })
      },

      getPublicAuction(auctionId) {
        return this.query(`${coreService}/anon/auctions/${auctionId}`)
      },

      getTenantAuctions() {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions`, true, {
          queryOptions: {
            params: {
              offset: 0,
              limit: 10000
            }
          }
        })
      },

      getAuction(auctionId) {
        if (!store.getters.authenticatedUser) {
          return this.getPublicAuction(auctionId)
        }
        return this.query(`${coreService}/auth/auctions/${auctionId}`, true)
      },

      getBuyerRequirementsOptions() {
        return this.query(`${coreService}/auth/auctions/buyerRequirements`, true)
      },

      postAuction(data) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      putAuction(auctionId, data) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}`, true, {
          queryOptions: {
            method: 'PUT',
            body: JSON.stringify(data)
          }
        })
      },

      deleteAuction(auctionId) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      cancelAuction(auctionId, reason) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/cancel`, true, {
          queryOptions: {
            method: 'PUT',
            body: JSON.stringify({ reason })
          }
        })
      },

      postAuctionPhotos(auctionId, data) {
        if (!Array.isArray(data)) {
          data = [ data ]
        }
        //return this.query(`https://test.localhost/proxy/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/photo`, true, {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/photo`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          },
          timeout: 1000 * 60 * 4
        })
      },

      deleteAuctionPhotos(photoUrls) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/photo`, true, {
          queryOptions: {
            method: 'DELETE',
            body: JSON.stringify({ photos: photoUrls })
          }
        })
      },

      putAuctionBuyerRequirements(auctionId, data) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/requirements`, true, {
          queryOptions: {
            method: 'PUT',
            body: JSON.stringify(data)
          }
        })
      },

      postAuctionRegister(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/register`, true, {
          queryOptions: {
            method: 'POST',
            body: ''
          }
        })
      },

      postAuctionApplicationSave(subdomain, auctionId, data) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/save`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      postAuctionApplicationSubmit(subdomain, auctionId, data) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/submit`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      postAuctionApplicationAccept(subdomain, auctionId, applicationId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/${applicationId}/accept`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({})
          }
        })
      },

      postAuctionApplicationDecline(subdomain, auctionId, applicationId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/${applicationId}/decline`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({})
          }
        })
      },

      postAuctionApplicationApplicant(subdomain, auctionId, applicationId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/${applicationId}/applicant`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({})
          }
        })
      },

      postAuctionApplicationMessage(subdomain, auctionId, applicationId, message) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/${applicationId}/message`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ message })
          }
        })
      },

      postBuyerRequirementStatus(subdomain, auctionId, applicationId, buyerRequirementId, status) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/applications/${applicationId}/requirementstatus/${buyerRequirementId}/${status}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      // newStatus: 'PROCESSING', 'IN_ESCROW' or 'CLOSED'
      changeAuctionStatus(subdomain, auctionId, newStatus) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/status/${newStatus}`, true, {
          queryOptions: {
            method: 'PUT'
          }
        })
      },

      changeAuctionWinner(subdomain, auctionId, auctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/winner/${auctionRoleId}`, true, {
          queryOptions: {
            method: 'PUT'
          }
        })
      },

      getAuctionParticipants(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/participants`, true)
      },

      getAuctionApplication(subdomain, auctionId, auctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/role/${auctionRoleId}`, true)
      },

      getAuctionSellingAgent(subdomain, auctionId, buyerAuctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/role/${buyerAuctionRoleId}/sellingagent`, true)
      },

      getAuctionBuyerObservers(subdomain, auctionId, buyerAuctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/role/${buyerAuctionRoleId}/observers`, true)
      },

      getAuctionBuyers(subdomain, auctionId, collaboratorAuctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/role/${collaboratorAuctionRoleId}/buyers`, true)
      },

      getAuctionWinner(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/winner`, true)
      },

      getMyApplications() {
        return this.query(`${coreService}/auth/my/applications`, true)
      },

      getMyAuctions() {
        return this.query(`${coreService}/auth/my/auctions`, true)
      },

      getAllAuctions() {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/`, true)
      },

      getListings(userId) {
        return this.query(`${coreService}/auth/my/tenant/${store.getters.subdomain}/listings/${userId}`, true)
      },

      getDelegated(userId) {
        return this.query(`${coreService}/auth/my/tenant/${store.getters.subdomain}/delegated`, true)
      },

      getAuctionDelegatedAgents(auctionId) {
        return this.query(`${coreService}/anon/auctionrole/delegated/${auctionId}`, true)
      },

      postDelegatedAgents(auctionId, data) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/delegate/updateList`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      getPrincipals() {
        return this.query(`${coreService}/auth/my/tenant/${store.getters.subdomain}/principals`, true)
      },

      postBid(subdomain, auctionId, amount) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/bids`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ amount })
          }
        })
      },

      fileUpload(auctionId, fileData) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/files`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(fileData)
          },
          timeout: 1000 * 60 * 2
        })
      },

      getAuctionFiles(subdomain, auctionId, type) {
        switch (type) {
          case 'AUTHORIZED':
            return this.getAuthorizedAuctionFiles(subdomain, auctionId)
          case 'LOGGED_IN':
            return this.getLoggedInAuctionFiles(subdomain, auctionId)
          case 'PUBLIC':
            return this.getPublicAuctionFiles(subdomain, auctionId)
          case 'PRIVATE':
            return this.getPrivateAuctionFiles(subdomain, auctionId)
          default:
            console.error('getAuctionFiles with invalid type [%s]', type)
            return Promise.reject()
        }
      },

      getAuthorizedAuctionFiles(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/files/authorized`, true)
      },

      getLoggedInAuctionFiles(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/files/loggedin`, true)
      },

      getPublicAuctionFiles(subdomain, auctionId) {
        return this.query(`${coreService}/anon/tenant/${subdomain}/auctions/${auctionId}/files/public`, false)
      },

      getPrivateAuctionFiles(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/files/private`, true)
      },

      initiateFileDownload(subdomain, auctionId, fileId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/files/download/${fileId}`, true)
      },

      initiatePublicFileDownload(subdomain, auctionId, fileId) {
        return this.query(`${coreService}/anon/tenant/${subdomain}/auctions/${auctionId}/files/download/${fileId}`)
      },

      deleteFile(auctionId, fileId) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/files/delete/${fileId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      readAutoBid(subdomain, auctionId, auctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/autobid/${auctionRoleId}`, true)
      },

      updateAutoBid(subdomain, auctionId, auctionRoleId, payload) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/autobid/${auctionRoleId}`, true, {
          queryOptions: {
            method: 'PUT',
            body: JSON.stringify(payload)
          }
        })
      },

      deleteAutoBid(subdomain, auctionId, auctionRoleId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/autobid/${auctionRoleId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      getBidsForAuction(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/bids`, true)
      },

      createAuctionInvitation(subdomain, auctionId, auctionRoleId, auctionInvitationRole, email) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/invitations/role/${auctionRoleId}/${auctionInvitationRole}`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ email })
          }
        })
      },

      createAuctionInvitationForBuyer(subdomain, auctionId, email) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/invitations/buyer`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ email })
          }
        })
      },

      getAuctionInvitations(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/invitations`, true)
      },

      getAuctionInvitationsByMe(subdomain, auctionId) {
        return this.query(`${coreService}/auth/tenant/${subdomain}/auctions/${auctionId}/invitations/byme`, true)
      },

      getAuctionInvitation(token) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/0/invitations/${token}`, true)
      },

      useAuctionInvitation(auctionId, token) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/auctions/${auctionId}/invitations/${token}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      getAuditTrailData(entityType, entityId) {
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/audit/${entityType.toUpperCase()}/${entityId}`)
      },

      loadWatchlist() {
        return this.query(`${userService}/auth/watchlist`, true)
      },

      toggleWatchlistStatus(auctionId, remove) {
        return this.query(`${userService}/auth/watchlist/${auctionId}`, true, {
          queryOptions: {
            method: remove ? 'DELETE' : 'POST'
          }
        })
      },

      getWatchlistAuctions() {
        return this.resolveTenantData(this.query(`${coreService}/auth/my/watchlist`, true))
      },

      getPfxAdminTenants() {
        return this.query(`${coreService}/auth/pfxadmin/tenant`, true)
      },

      getPfxAdminTenantStatistics(subdomain) {
        return this.query(`${coreService}/auth/pfxadmin/tenant/${subdomain}/statistics`, true)
      },

      postPfxAdminTenantStatus(subdomain, status) {
        return this.query(`${coreService}/auth/pfxadmin/tenant/${subdomain}/status/${status}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },
      deletePfxAgent(userId){
        return this.query(`${coreService}/auth/tenant/${store.getters.subdomain}/members/deleteUser/${userId}`, true, {
          queryOptions:{
            method: 'DELETE'
          }
        })
      },

      deletePfxAdminTenant(subdomain) {
        return this.query(`${coreService}/auth/pfxadmin/tenant/${subdomain}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      getPfxAdminTenantMembers(subdomain) {
        return this.query(`${coreService}/auth/pfxadmin/tenant/${subdomain}/members`, true)
      },

      postPfxAdminTenantMemberInvite(subdomain, email) {
        return this.query(`${coreService}/auth/pfxadmin/tenant/${subdomain}/member/invite`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify({ email })
          }
        })
      },

      postTenantApplication(application) {
        return this.query(`${coreService}/auth/applications`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(application)
          }
        })
      },

      getMyTenantApplication() {
        return this.query(`${coreService}/auth/applications/my`, true)
      },

      putMyTenantApplication(application) {
        return this.query(`${coreService}/auth/applications/my`, true, {
          queryOptions: {
            method: 'PUT',
            body: JSON.stringify(application)
          }
        })
      },

      getPfxAdminApplications() {
        return this.query(`${coreService}/auth/applications`, true)
      },

      getPfxAdminApplication(tenantApplicationId) {
        return this.query(`${coreService}/auth/applications/${tenantApplicationId}`, true)
      },

      getPfxAdminApplicationRole(userId) { // pfx admins can get the tenant_role of any user (applicant) to verify can be be an admin of another
        return this.query(`${coreService}/auth/applications/role/${userId}`, true)
      },

      deletePfxAdminApplication(tenantApplicationId) {
        return this.query(`${coreService}/auth/applications/${tenantApplicationId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      acceptPfxAdminApplication(tenantApplicationId, data) {
        return this.query(`${coreService}/auth/applications/${tenantApplicationId}/accept`, true, {
          queryOptions: {
            method: 'POST',
            body: JSON.stringify(data)
          }
        })
      },

      getPfxAdminUsers() {
        return this.query(`${coreService}/auth/pfxadmin/user`, true)
      },

      addPfxAdminUser(userId) {
        return this.query(`${coreService}/auth/pfxadmin/user/${userId}`, true, {
          queryOptions: {
            method: 'POST'
          }
        })
      },

      removePfxAdminUser(userId) {
        return this.query(`${coreService}/auth/pfxadmin/user/${userId}`, true, {
          queryOptions: {
            method: 'DELETE'
          }
        })
      },

      query(url, authRequired = false, args = {}) {
        return new Promise((resolve, reject) => {
          this.prepareOptions(args.queryOptions, authRequired)
          .then(options => {
            return this.makeRequest(this.prepareUrl(url, args), options, args.timeout)
              .then(data => resolve(data))
              .catch(err => reject(this.handleError(err)))
          })
          .catch(err => reject(this.handleError(err)))
        })
      },

      prepareUrl(url, args) {
        return `${url}${args.params ? this.objectToQueryString(args.params) : ''}`
      },

      objectToQueryString(obj) {
        let query = Object.keys(obj)
          .filter(key => obj[key] !== '' && obj[key] !== null)
          .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
          .join('&')
        return query.length > 0 ? '?' + query : ''
      },

      prepareOptions(queryOptions = {}, authRequired) {
        return new Promise((resolve, reject) => {
          this.getAuthHeader(authRequired)
            .then(auth => {
              const defaultOptions = JSON.parse(JSON.stringify(defaultQueryOptions)) // Deep clone to keep defaultQueryOptions intact
              const options = Object.assign(defaultOptions, queryOptions)
              if (authRequired) {
                options.headers = Object.assign(options.headers, auth.headers)
              }
              if (queryOptions.headers) {
                options.headers = Object.assign(options.headers, queryOptions.headers)
              }
              resolve(options)
            })
            .catch(err => {
              reject(err)
            })
        })
      },

      getAuthHeader(authRequired) {
        return new Promise((resolve, reject) => {
          if (!authRequired) {
            resolve({})
            return
          }
          const user = store.getters.userPool.getCurrentUser()
          if (!user) {
            store.commit('setTargetPage', router.history.current.path)
            store.commit('openSignUpDialog')
            reject({ status: 418, data: { message: 'Authentication required' } })
            return
          }
          user.getSession((err, session) => {
            if (err) {
              reject({ status: 401, data: { message: 'session expired' } })
              return
            }
            resolve({
              headers: {
                Authorization: session.getIdToken().jwtToken
              }
            })
          })
        })
      },

      makeRequest(url, options, timeout) {
        return new Promise((resolve, reject) => {
          let timer = setTimeout(function() {
            reject({ status: 504, statusText: 'query timeout' })
          }, timeout || DEFAULT_FETCH_TIMEOUT)

          fetch(url, options)
            .then(response => {
              clearTimeout(timer)
              this.handleResponse(response)
              .then(data => {
                response.ok ? resolve(data) : reject(data)
              })
            })
            .catch(error => {
              // catches all calls which get no response at all, i.e. when the server is down
              console.warn('PfxBackendApi: error in query (unable to get response)', error, 'typeof:', typeof error)
              reject({ status: 500, data: { message: 'no response' } })
            })
        })
      },

      handleResponse(response) {
        return new Promise((resolve, reject) => {
          let payload = { status: response.status }
          response
            .json()
            .then(obj => {
              console.debug('PfxBackendApi: %s %s', response.ok ? 'OK' : 'NOK', response.url)
              payload.data = obj
              resolve(payload)
            })
            .catch(() => {
              console.debug('PfxBackendApi: unable to parse json. returning an empty object.')
              payload.data = {}
              resolve(payload)
            })
        })
      },

      handleError(error) {
        console.log(`Query error: ${JSON.stringify(error)}`)
        if (error.status === 401) {
          router.push('/session-expired')
        }
        return error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/PfxBackendApiPlugin.js